<template>
  <div>
    <div class="diaContainer yauto">
      <!-- 告知书 新增/编辑 表单 -->
      <el-form
        ref="addNotifyForm1"
        :model="addNotifyForm"
        v-if="showForm==='showFormNotifyAdd'"
        label-position="right"
        label-width="160px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" v-else>
              <!-- 远程搜索 -->
              <el-select
                style="width:100%"
                v-model="addNotifyForm.project_id"
                filterable
                remote
                multiple
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                :filter-method="projectSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">告知信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addNotifyForm.member">
              <span
                v-if="addNotifyForm.member"
                style="color:#666;font-size:16px"
              >{{addNotifyForm.member.nickname}}</span>
            </el-form-item>
            <!-- 文件名称 -->
            <el-form-item label="文件名称">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入文件名称"
                v-model="addNotifyForm.notify_name"
              ></el-input>
            </el-form-item>
            <!-- 告知人 -->
            <el-form-item label="告知人">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入告知人"
                v-model="addNotifyForm.notifier"
              ></el-input>
            </el-form-item>
            <!-- 被告知人 -->
            <el-form-item label="被告知人">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入被告知人"
                v-model="addNotifyForm.notified_person"
              ></el-input>
            </el-form-item>
            <!-- 告知单位 -->
            <el-form-item label="告知单位">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入告知单位"
                v-model="addNotifyForm.notified_unit"
              ></el-input>
            </el-form-item>
            <!-- 告知时间 -->
            <el-form-item label="告知时间">
              <el-date-picker
                style="width:100%"
                v-model="addNotifyForm.notify_time"
                :disabled="draftDisable"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择告知时间"
              ></el-date-picker>
            </el-form-item>
            <!-- 其他附件 -->
            <el-form-item label="告知书附件">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="annexList"
                :detailsImgList="annexDetails"
                @my-upload-change="handleAnnexUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addNotifyForm.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 告知书 详情（只读） 表单 -->
      <el-form
        ref="addNotifyForm2"
        :model="addNotifyForm"
        v-if="showForm==='showFormNotifyHandle' && $store.state.process.admin.dialogVisible"
        label-position="right"
        label-width="160px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
              <span
                class="projectContainerInbox"
                v-for="(items,index) in addNotifyForm.project_list"
                :key="items.project_id"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addNotifyForm.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name}}</span>
              </span>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">告知信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addNotifyForm.member">
              <span
                v-if="addNotifyForm.member"
                style="color:#666;font-size:16px"
              >{{addNotifyForm.member.nickname}}</span>
            </el-form-item>
            <!-- 文件名称 -->
            <el-form-item label="文件名称">
              <span style="color:#666;font-size:16px">{{addNotifyForm.notify_name}}</span>
            </el-form-item>
            <!-- 告知人 -->
            <el-form-item label="告知人">
              <span style="color:#666;font-size:16px">{{addNotifyForm.notifier}}</span>
            </el-form-item>
            <!-- 被告知人 -->
            <el-form-item label="被告知人">
              <span style="color:#666;font-size:16px">{{addNotifyForm.notified_person}}</span>
            </el-form-item>
            <!-- 告知单位 -->
            <el-form-item label="告知单位">
              <span style="color:#666;font-size:16px">{{addNotifyForm.notified_unit}}</span>
            </el-form-item>
            <!-- 告知时间 -->
            <el-form-item label="告知时间">
              <span style="color:#666;font-size:16px">{{addNotifyForm.notify_time}}</span>
            </el-form-item>
            <!-- 其他附件 -->
            <el-form-item label="告知书附件">
              <upload-file
                style="width:100%"
                :isSubmit="false"
                :imgList="annexList"
                :detailsImgList="annexDetails"
                @my-upload-change="handleAnnexUploadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-model="addNotifyForm.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 新增/编辑态：保存草稿 + 提交 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormNotifyAdd' && !draftDisable"
        @click="handleNotifySubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormNotifyAdd' && !draftDisable"
        @click="handleNotifySubmit('0')"
        :disabled="disableLimit"
      >提交</el-button>
      <!-- 详情只读态：关闭 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormNotifyHandle'"
        @click="getDialogVisible(false)"
      >关闭</el-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import UploadFile from '../../../components/UploadFile'

export default {
  data() {
    return {
      // 禁用按钮防抖
      disableLimit: false,

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      tiemID: null,
      timeDou: 100,
      // 告知书表单数据
      // is_draft 由后端回填（'0' 提交 / '1' 草稿）
      addNotifyForm: {
        remark: '',
        annex: '',
        project_id: [],
        notify_name: '',
        notifier: '',
        notified_person: '',
        notified_unit: '',
        notify_time: '',
      },

      // 其他附件列表
      annexList: [],
      annexDetails: [],
    }
  },
  components: {
    UploadFile,
  },
  watch: {
    '$store.state.process.admin.formData'(newval, olval) {
      this.addNotifyForm = newval
      this.handleFormDataChange(newval)
    },
    '$store.state.process.admin.dialogVisible'(newval, olval) {
      // 关闭弹窗时重置本地图片状态
      if (newval === false) {
        this.annexList = []
        this.annexDetails = []
      }
    },
  },
  methods: {
    ...mapMutations('process/admin', ['getDialogVisible']),
    // 项目远程搜索
    async projectSearch(val) {
      if (!val) return
      let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      param.append(
        'cache_department_id',
        localStorage.getItem('bthl_process_cache_department_id_store') || ''
      )
      param.append(
        'company_id',
        localStorage.getItem('bthl_process_LoginCompanyId') || ''
      )
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$store.commit('process/admin/assignmentProject', res.datas.listInfo)
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo
        )
      }
    },

    // 项目名称变更（多选限定 1 个）
    async handleProjectSelectChange1(val) {
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addNotifyForm.project_id = [val[0]]
      }
      this.$forceUpdate()
    },

    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },

    // 其他附件上传变更
    handleAnnexUploadChange(data) {
      this.annexList = data
    },

    // 同步表单数据到本地图片列表（详情/编辑场景）
    handleFormDataChange(formData) {
      if (formData.annex && formData.annex.length > 0) {
        this.annexList = formData.annex
        this.annexDetails = formData.annex
      } else {
        this.annexList = []
        this.annexDetails = []
      }
    },

    // 提交保存（新增/编辑共用）
    // isDraft: '1' = 保存草稿，'0' = 提交
    async handleNotifySubmit(isDraft) {
      this.disableLimit = true
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        // 项目id（编辑时携带 finance_id 走 edit 接口）
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addNotifyForm.project_id.join(','))
        }

        param.append('notify_name', this.addNotifyForm.notify_name || '')
        param.append('notifier', this.addNotifyForm.notifier || '')
        param.append('notified_person', this.addNotifyForm.notified_person || '')
        param.append('notified_unit', this.addNotifyForm.notified_unit || '')
        param.append('notify_time', this.addNotifyForm.notify_time || '')
        param.append('annex', JSON.stringify(this.annexList))
        param.append('remark', this.addNotifyForm.remark || '')
        param.append('is_draft', isDraft)

        // 判断是新增还是编辑
        const isEdit = this.addNotifyForm.id ? true : false
        if (isEdit) {
          param.append('finance_id', this.addNotifyForm.id)
        }

        const url = isEdit
          ? '/api/Service/notify_edit'
          : '/api/Service/notify_add'

        const { data: res } = await this.$axios({
          method: 'post',
          url,
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        this.getDialogVisible(false)
      }, this.timeDou)
    },

    getList() {
      this.$store.commit('process/admin/getNotifyList')
    },
  },

  async created() {
    const formData = JSON.parse(
      JSON.stringify(this.$store.state.process.admin.formData)
    )
    this.addNotifyForm = formData
    this.handleFormDataChange(formData)
    this.disableLimit = false
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
  mounted() {},
  computed: {
    ...mapState('process/admin', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList',
      'projectListSub',
    ]),
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
</style>
